import { useTranslation } from 'react-i18next';
import CustomerBoIam from '@components/back-office/customer/customer-bo-iam.tsx';
import CustomerBoIamGroups from '@components/back-office/customer/customer-bo-iam-groups';
import ResellerBoSubOrganizations from '@pages/back-office/reseller-bo-sub-organizations.tsx';
import Tabs, { Tab } from '@components/atoms/ui-kit/tabs.tsx';
import { Users, UsersRound, Building2 } from 'lucide-react';
import Breadcrumb from '@components/atoms/ui-kit/breadcrumb.tsx';
import { Params, useParams } from 'react-router-dom';
import { useGetCustomerById } from '@utils/api/back-office/customer-bo/use-get-customer-bo.tsx';
import { PATHS } from '../../../router/paths';

export enum IamTabs {
  IamUsers = 'IAM Users',
  IamGroups = 'IAM Groups',
  SubOrganizations = 'Sub-Organizations'
}

export default function CustomerBoIamPage() {
  const { customerId } = useParams<Params>();
  const { t } = useTranslation();
  const { data, isError } = useGetCustomerById(Number(customerId));

  const isReseller = !!data?.result?.is_reseller;
  const customerName = data?.result?.name || t('customer');

  const breadcrumbItems = [
    { label: t('customers'), path: PATHS().CUSTOMERS },
    { label: customerName, path: PATHS(customerId || '').CUSTOMER_CONTENT },
    { label: t('iam') }
  ];

  const baseTabs: Tab[] = [
    {
      id: 0,
      name: (
        <span className="flex items-center gap-2">
          <Users className="h-4 w-4" />
          {t('iam-users')}
        </span>
      ),
      component: <CustomerBoIam />
    },
    {
      id: 1,
      name: (
        <span className="flex items-center gap-2">
          <UsersRound className="h-4 w-4" />
          {t('iam-groups')}
        </span>
      ),
      component: <CustomerBoIamGroups />
    }
  ];

  const tabsWithConditional = isReseller
    ? [
        ...baseTabs,
        {
          id: 2,
          name: (
            <span className="flex items-center gap-2">
              <Building2 className="h-4 w-4" />
              {t('sub-organizations')}
            </span>
          ),
          component: <ResellerBoSubOrganizations />
        }
      ]
    : baseTabs;

  if (isError) {
    return (
      <div className="bg-app flex-1 flex items-center justify-center">
        <p className="text-sm">{t('error-loading-customer')}</p>
      </div>
    );
  }

  return (
    <div className="bg-app flex-1 min-h-0 flex flex-col">
      <div className="my-2 px-4 py-2 flex-1 min-h-0 flex flex-col">
        <div>
          <Breadcrumb items={breadcrumbItems} />
        </div>
        <Tabs
          tabs={tabsWithConditional}
          searchParams
          minHeight="0"
          maxHeight="100%"
        />
      </div>
    </div>
  );
}
